import { FunctionComponent, ReactNode } from 'react';
import Modal from '../../Utility/Modal/Modal';

import BaseDialogue, { Status } from './BaseDialogue';

interface BaseProps {
  title: ReactNode;
  subTitle?: ReactNode;
  isVisible: boolean;
  subInfo?: string;
  content?: string;
  status: Status;
  width?: string;
  buttonColor?: 'primary' | 'secondary' | 'outlined' | 'none' | 'hover';
  buttonBackgroundColor?: string;
  buttonTextColor?: string;
  buttonWidth?: string;
  buttonRound?: boolean;
  variant?: 'paylink' | 'creditCard' | 'onBoarding';
  buttonCancelColor?: 'primary' | 'secondary' | 'outlined' | 'none' | 'hover';
  buttonCancelTextColor?: string;
  element?: ReactNode;
}

export interface ConfirmationDialogueProps extends BaseProps {
  confirm?: {
    label: string;
    action: () => void;
  };
  cancel?: {
    label: string;
    action: () => void;
  };
  close?: {
    action: () => void;
  };
}

type FC = FunctionComponent<ConfirmationDialogueProps>;

const ConfirmationDialogue: FC = (props: ConfirmationDialogueProps) => {
  const {
    isVisible,
    title,
    subTitle,
    content,
    confirm,
    close,
    cancel,
    subInfo,
    status,
    width,
    buttonColor = 'primary',
    buttonBackgroundColor,
    buttonTextColor = 'auto',
    buttonWidth,
    variant,
    buttonRound,
    element,
  } = props;

  return (
    <Modal isVisible={isVisible} enableBgClick={false} variant={variant}>
      <BaseDialogue
        variant={variant}
        status={status}
        subInfo={subInfo}
        title={title}
        subTitle={subTitle}
        content={content}
        confirm={confirm}
        close={close}
        width={width}
        cancel={cancel}
        buttonColor={buttonColor}
        buttonBackgroundColor={buttonBackgroundColor}
        buttonTextColor={buttonTextColor}
        buttonWidth={buttonWidth}
        buttonRound={buttonRound}
        element={element}
        data-testid="confirmation-dialogue"
      />
    </Modal>
  );
};

export default ConfirmationDialogue;
